var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 5.73C19.46 5.57 17.85 5.45 16.23 5.36V5.35L16.01 4.05C15.86 3.13 15.64 1.75 13.3 1.75H10.68C8.35004 1.75 8.13004 3.07 7.97004 4.04L7.76004 5.32C6.83004 5.38 5.90004 5.44 4.97004 5.53L2.93004 5.73C2.51004 5.77 2.21004 6.14 2.25004 6.55C2.29004 6.96 2.65004 7.26 3.07004 7.22L5.11004 7.02C10.35 6.5 15.63 6.7 20.93 7.23C20.96 7.23 20.98 7.23 21.01 7.23C21.39 7.23 21.72 6.94 21.76 6.55C21.79 6.14 21.49 5.77 21.07 5.73Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 8.64C18.99 8.39 18.66 8.25 18.32 8.25H5.67999C5.33999 8.25 4.99999 8.39 4.76999 8.64C4.53999 8.89 4.40999 9.23 4.42999 9.58L5.04999 19.84C5.15999 21.36 5.29999 23.26 8.78999 23.26H15.21C18.7 23.26 18.84 21.37 18.95 19.84L19.57 9.59C19.59 9.23 19.46 8.89 19.23 8.64ZM13.66 18.25H10.33C9.91999 18.25 9.57999 17.91 9.57999 17.5C9.57999 17.09 9.91999 16.75 10.33 16.75H13.66C14.07 16.75 14.41 17.09 14.41 17.5C14.41 17.91 14.07 18.25 13.66 18.25ZM14.5 14.25H9.49999C9.08999 14.25 8.74999 13.91 8.74999 13.5C8.74999 13.09 9.08999 12.75 9.49999 12.75H14.5C14.91 12.75 15.25 13.09 15.25 13.5C15.25 13.91 14.91 14.25 14.5 14.25Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e1f6acde3f8754aaff532b189edfe850.svg";
export { ForwardRef as ReactComponent };